import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import R from './Routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <R />
  </React.StrictMode>
);